import React from 'react'
import { useTranslation } from 'react-i18next'
import {Typography} from 'antd'
import {observer} from 'mobx-react'

import {formatSortCode} from '@/services/utils'

import type {BankAccountDetailsProps} from './props'

export const BankAccountDetails = observer(
    ({accountNumber, sortCode, label}: BankAccountDetailsProps) => {
        const { t } = useTranslation()
        return (
            <>
                {label && (
                    <>
                        <Typography.Text>{label}</Typography.Text>
                        <br />
                    </>
                )}
                <Typography.Text>
                    {t('ChangeBankAccountDetails.labels.accountNumber')}: {accountNumber}
                </Typography.Text>
                <br />
                <Typography.Text>
                    {t('ChangeBankAccountDetails.labels.sortCode')}: {formatSortCode(sortCode)}
                </Typography.Text>
            </>
        )
    }
)
